<template>
  <div class="link-field">
    <div v-if="question.label" class="field-label">{{ question.label }}</div>
    <div class="field-value">
      <a
        v-if="value"
        :href="value"
        target="_blank"
        rel="noopener noreferrer"
        class="text-primary"
      >
        {{ value }}
      </a>
      <span v-else class="text-muted">No link provided</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LinkField',
  props: {
    value: {
      type: String,
      default: '',
    },
    question: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style scoped>
.link-field {
  word-break: break-all;
}

.field-value {
  min-height: 1.5rem;
}
</style> 